<script>
import { APPLICATION_STATUS_WAITTING } from 'rpc/MisComm/MisComm'
import { mapActions } from 'vuex'
export default {
  name: 'existApply',
  methods: {
    ...mapActions([
      'getUserInfoAction'
    ]),
    isExistCompanyApply () {
      let status = true
      let api = this.$apiUtil.getMisCommApi()
      api.getJoinCompanyApplication().then((data) => {
        if (data.applicationInfo.status === APPLICATION_STATUS_WAITTING) {
          this.$router.push('/joinCompany')
          status = false
        } else {
          status = this.isExistUserCompany()
        }
      }).catch((error) => {
        this.$log.error('getJoinCompanyApplication' + error)
      })
      return status
    },
    isExistUserCompany () {
      let status = true
      this.getUserInfoAction().then((userInfo) => {
        if (!userInfo.isBoundCompany) {
          this.$router.push('/addCompany')
          status = false
        }
        status = true
      }).catch((error) => {
        this.$log.error('getUserInfoAction failed' + error)
      })
      return status
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/apps/baseapp/views/components/existApply.vue